import { memo, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./HomeLayout.scss";
import { sendTagOnSDPSearchPage } from "app/utils/analytics";
import { DynamicBlocksRendererContainer } from "app/pages/.shared/DynamicBlocks";
import { PushNotificationContainer } from "app/pages/.shared/PushNotification/PushNotificationContainer";
import SmartDPMarketingHeroImageContainer from "app/pages/SmartDP/SmartDPMarketingHeroImage/SmartDPMarketingHeroImageContainer";
import SmartDPMarketingHeadlineContainer from "app/pages/SmartDP/SmartDPMarketingHeadline/SmartDPMarketingHeadlineContainer";
import HeaderContainer from "app/pages/Header/HeaderContainer";
import classNames from "classnames";
import SmartDPSearchHeadMetadata from "app/pages/SmartDP/Search/SmartDPSearchHeadMetadata";
import WebsiteTunnelSwitcherContainer from "app/pages/.shared/WebsiteTunnelSwitcher/WebsiteTunnelSwitcherContainer";
import { isEmpty } from "lodash";
import SmartDPHeroCommercial from "app/pages/SmartDP/SmartDPHeroCommercial/SmartDPHeroCommercial";
import Loader from "app/pages/.shared/Loader";

const HomeLayout = ({
	websiteTunnels = [],
	homeBlocks = [],
	isBrandWithCustomHeader,
	heroCommercialMerch = {},
	isTransparentHeader,
	brandCode,
	heroCommercialCode,
}) => {
	const smartDPSearchRef = useRef(null);

	useEffect(() => {
		sendTagOnSDPSearchPage();
	}, []);

	const containerClass = classNames({
		"home-layout__container": true,
		"home-layout__container--custom-header": isBrandWithCustomHeader || !isTransparentHeader,
	});
	const homeLayoutImageClass = classNames("home-layout__image", {
		"home-layout__image--commercial": !isEmpty(heroCommercialMerch),
	});

	const displayLoading = heroCommercialCode && isEmpty(heroCommercialMerch);
	let heroCommercialContent;
	if (displayLoading) {
		heroCommercialContent = (
			<div className="home-layout__loader">
				<Loader />
			</div>
		);
	} else {
		heroCommercialContent = (
			<SmartDPHeroCommercial
				websiteTunnels={websiteTunnels}
				heroCommercialMerch={heroCommercialMerch}
			/>
		);
	}
	return (
		<div ref={smartDPSearchRef} className="home-layout">
			<SmartDPSearchHeadMetadata />
			<HeaderContainer brandCode={brandCode} />
			<div className={containerClass}>
				<div className={homeLayoutImageClass}>
					{heroCommercialCode ? (
						heroCommercialContent
					) : (
						<>
							<div className="home-layout__image-background">
								<SmartDPMarketingHeroImageContainer
									isBackgroundProgressiveImg={true}
								/>
							</div>
							<div className="home-layout__image-headline">
								<SmartDPMarketingHeadlineContainer />
								<div className="home-layout__form">
									<WebsiteTunnelSwitcherContainer
										websiteTunnels={websiteTunnels}
									/>
								</div>
							</div>
						</>
					)}
				</div>
				<div className="home-layout__content">
					<div className="home-layout__dynamic-blocks">
						<DynamicBlocksRendererContainer blocks={homeBlocks} />
					</div>
				</div>
			</div>
			<PushNotificationContainer />
		</div>
	);
};

HomeLayout.propTypes = {
	websiteTunnels: PropTypes.array,
	homeBlocks: PropTypes.array,
	heroCommercialCode: PropTypes.string,
	isBrandWithCustomHeader: PropTypes.bool,
	heroCommercialMerch: PropTypes.object,
	brandCode: PropTypes.string,
	isTransparentHeader: PropTypes.bool,
};

export default memo(HomeLayout);
